<template>
  <div class="container">
    <div v-if="showVote">
      <h1>{{ currentPage.title }}</h1>
      <choices :selectable="true"
               :instant-selection="true"
               :choice-type="choiceComponentOptions && choiceComponentOptions.choiceType ? choiceComponentOptions.choiceType : 'multipleChoice'"
               class="choices"
               type="vertical"
               v-bind:choices="choices"
               v-bind:value="activeChoiceIndexes"
               v-on:value="activeChoiceIndexes = $event;"
              v-on:submit="onSubmitChoice"/>
    </div>
    <div class="center" v-else-if="currentMediaUrl">
      <h1>{{ $t('game.studentWaiting') }}</h1>
      <div class="media-container">
        <img :src="currentMediaUrl"/>
      </div>
    </div>
    <div class="center" v-else>
      <h1>{{ $t('game.studentWaiting') }}</h1>
    </div>
  </div>
</template>

<script>
import PagePhase from '@/enum/PagePhase'
import {mapGetters} from 'vuex'
import LoadingIndicator from '@/components/loading-indicator'
import AppButton from '@/components/app-button'
import Choices from '@/components/choices'
import ThingToHtml from '../../../../lib/ThingToHtmlVue/thing-to-html'
import {getStudentUrl} from '@/utils/UrlUtil'

export default {
  components: {
    ThingToHtml,
    Choices,
    AppButton,
    LoadingIndicator
  },
  data() {
    return {
      activeChoiceIndexes: [],
      sentVote: false,
      currentMediaUrl: null
    }
  },
  watch: {
    currentPagePhase(currentPagePhase) {
      if (currentPagePhase === PagePhase.Result) {
        // Reset sent vote
        this.sentVote = false
      }

      this.reloadImageUrl();
    },
    currentPage(currentPage) {
      this.reloadImageUrl();
    }
  },
  computed: {
    ...mapGetters({
      currentTheme: 'getCurrentTheme',
      currentCase: 'getCurrentCase',
      currentGamePhase: 'getCurrentGamePhase',
      currentPageIndex: 'getCurrentPageIndex',
      currentPagePhase: 'getCurrentPagePhase',
    }),
    currentPage() {
      if (!this.currentCase) {
        return null;
      }

      if (this.currentCase.pages.length < this.currentPageIndex - 1) {
        return null;
      }

      return this.currentCase.pages[this.currentPageIndex];
    },
    currentPageComponents() {
      if (!this.currentPage) {
        return null;
      }

      if (!this.currentPage.components) {
        return null;
      }

      return this.currentPage.components;
    },
    leftComponentType() {
      if (!this.currentPageComponents) {
        return null;
      }

      if (!this.currentPageComponents.left) {
        return null;
      }

      return this.currentPageComponents.left.component;
    },
    rightComponentType() {
      if (!this.currentPageComponents) {
        return null;
      }

      if (!this.currentPageComponents.right) {
        return null;
      }

      return this.currentPageComponents.right.component;
    },
    isChoiceComponent() {
      return this.leftComponentType === 'Choices' || this.rightComponentType === 'Choices';
    },
    choiceComponentOptions() {
      if (this.leftComponentType === 'Choices') {
        return this.currentPageComponents.left.options;
      } else if (this.rightComponentType === 'Choices') {
        return this.currentPageComponents.right.options;
      }

      return null;
    },
    showVote() {
      return this.isChoiceComponent && this.currentPagePhase === PagePhase.Normal && !this.sentVote;
    },
    choices() {
      if (!this.choiceComponentOptions) {
        return [];
      }

      return this.choiceComponentOptions.choices;
    },
    canSendVote() {
      console.log('canSendVote', this.sentVote, this.activeChoiceIndexes.length);
      if (this.sentVote) {
        return false;
      }

      if (this.activeChoiceIndexes.length <= 0) {
        return false;
      }

      return true;
    },
  },
  methods: {
    onSubmitChoice() {
      this.onClickAnswer();
    },
    reloadImageUrl() {
      let mediaUrl = null;

      if (this.currentPageComponents && this.currentPagePhase === PagePhase.Normal) {
        for (let side in this.currentPageComponents) {
          let component = this.currentPage.components[side].component;
          let componentOptions = this.currentPage.components[side].options;

          if (component === 'Media') {
            if (componentOptions.media) {
              mediaUrl = this.$apiClient.baseUrl + '/uploads/' + componentOptions.media.replace(/^\/+/, '');

              break;
            }
          }
        }
      }

      this.currentMediaUrl = mediaUrl;
    },
    onClickAnswer() {
      if (!this.canSendVote) {
        return;
      }

      this.$gameClient.send({
        currentVotes: this.activeChoiceIndexes
      })

      this.sentVote = true
    },
    onPageChange() {
      console.log('onPageChange', this.currentPage);

      /*if (this.isChoiceComponent) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.activeChoiceIndexes.push(1);

            this.onClickAnswer();
          }, 1000);
        })
      }*/
    }
  },
  mounted() {
    console.log('FLOW STUDENT 2-GAME MOUNTED');
    let error = null;

    if (!this.$gameClient) {
      error = 'Game client was empty';
    } else if (!this.$gameClient.isClientConnected()) {
      error = 'Game client not connected';
    } else if (!this.$gameClient.inRoom()) {
      error = 'Game client not in room';
    } else if (!this.currentCase) {
      error = 'No current case could be found';
    }

    if (error) {
      console.log('[STUDENT] Could not start game: ' + error);

      this.$router.push(getStudentUrl('connect'))

      return;
    }

    this.onPageChange();
  }
}
</script>

<style lang="less" scoped>
.center {
  position: absolute;
  top: 50%;
  text-align: center;
  width: 100%;
  left: 0;
  transform: translate(0, -50%);
  padding: 0 20px;
}

.answer-button-container {
  margin-top: 50px;
  text-align: center;
}

.media-container {
  img {
    max-width: 100%;
    max-height: 300px;
  }
}
</style>
